import React, { useEffect, useState } from "react";
import PagesIndex from "../../../PagesIndex";
import Index from "../../../Index";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import moment from "moment";
import AddCrypto from "./AddCrypto";
import {
  activeDeactiveCrypto,
  getCryptoActivityListAction,
  getCryptoListAction,
} from "../../../../redux/admin/action";
import ActivityCrypto from "./ActivityCrypto";
import { set } from "date-fns";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 750,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 2,
  borderRadius: 1,
};

const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 850,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 2,
  borderRadius: 1,
};

const CryptoList = () => {
  const [loading, setLoading] = useState(true);
  const [loadingActivity, setLoadingActivity] = useState(true);
  const [open, setOpen] = useState(false);
  const [openActivity, setOpenActivity] = useState(false);
  const navigate = PagesIndex.useNavigate();
  const [masterWarden, setMasterWarden] = useState([]);
  const [updateCrypto, setUpdateCrypto] = useState({});
  const [pageData, setPageData] = useState([]);
  const [search, setSearch] = useState("");
  const [filterData, setFilteredData] = useState([]);
  const [dataCryptoActivity, setDataCryptoActivity] = useState([]);
  const { adminToken } = PagesIndex.useSelector((state) => state.AdminReducer);

  const handleSearch = async (e) => {
    setSearch(e.target.value.trim());
  };

  const handelClose = () => {
    setOpen(false);
  };

  const handelCrpytoClose = () => {
    setOpenActivity(false);
    setDataCryptoActivity([]);
  };

  const handelCrpytoOpen = (id) => {
    setLoadingActivity(true);
    getCryptoActivityList(id);
    setOpenActivity(true);
  };

  const handleAddMasterWarden = () => {
    setOpen(true);
  };

  const getCryptoList = () => {
    getCryptoListAction(adminToken).then((res) => {
      setMasterWarden(res);
      setLoading(false);
    });
  };

  useEffect(() => {
    getCryptoList();
  }, []);

  useEffect(() => {
    const filtered = masterWarden?.filter((item) => {
      const searchLower = search?.toLowerCase();
      const createdAtFormatted = moment(item?.createdAt)?.format("DD/MM/YYYY");
      const updatedAtFormatted = moment(item?.updatedAt)?.format("DD/MM/YYYY");

      return (
        !search ||
        item?.networkName?.toLowerCase()?.includes(searchLower) ||
        String(item?.platformFee)?.includes(search) ||
        item?.networkAddress?.toLowerCase()?.includes(searchLower) ||
        item?.receiverAddress?.toLowerCase()?.includes(searchLower) ||
        createdAtFormatted?.includes(searchLower) ||
        updatedAtFormatted?.includes(searchLower) 
      );
    });

    setFilteredData(filtered || []);
  }, [masterWarden, search]);

  const copyToClipboard = async (address) => {
    try {
      await navigator.clipboard.writeText(address);
      Index.toast.success("Copied successfully");
    } catch (err) {
      Index.toast.error("Could not copy address");
    }
  };

  const handleSwitchChange = (event, id) => {
    setLoading(true);
    activeDeactiveCrypto({ id }, adminToken).then((res) => {
      if (res?.status === 200) {
        Index.toast.success(res?.message);
        getCryptoList();
      }
    });
  };

  const getCryptoActivityList = async(id) => {
    try {
    const res = await  getCryptoActivityListAction(id,adminToken);
    setDataCryptoActivity(res);
    setLoadingActivity(false);
    } catch (error) {
    setLoadingActivity(false);
    }
  };

  return (
    <>
      <Index.Box className="page-content-box">
        <Index.Box className="episap-common-box">
          <Index.Box className="title-header">
            <Index.Box className="title-header-flex res-title-header-flex">
              <Index.Box className="title-main">
                <Index.Typography
                  variant="p"
                  component="p"
                  className="page-title"
                >
                  Buy With Crypto Setup
                </Index.Typography>
              </Index.Box>
              <Index.Box className="d-flex align-items-center res-set-search">
                <PagesIndex.Search className="searchbar">
                  <PagesIndex.StyledInputBase
                    placeholder="Search"
                    inputProps={{ "aria-label": "search" }}
                    onChange={handleSearch}
                  />
                </PagesIndex.Search>
                {/* <Index.Link>
                  <Index.Button
                    variant="contained"
                    className="add-user-btn"
                    onClick={() => {
                      setUpdateCrypto("");
                      handleAddMasterWarden();
                    }}
                  >
                    Add crypto Network
                  </Index.Button>
                </Index.Link> */}
              </Index.Box>
            </Index.Box>
          </Index.Box>

          <Index.Box className="table-box table_scroll">
            <Index.TableContainer
              component={Index.Paper}
              className="episap-table-container"
            >
              <Index.Table
                stickyHeader
                aria-label="sticky table"
                className="episap-table-main user-list-table"
              >
                <Index.TableHead className="table-head">
                  <Index.TableRow>
                    <Index.TableCell align="left">No </Index.TableCell>
                    <Index.TableCell align="left">
                      Network Name{" "}
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Platform Fee(%){" "}
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Network Address{" "}
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Receiver Address
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Created Date & Time
                    </Index.TableCell>
                    <Index.TableCell align="left">
                      Updated Date & Time
                    </Index.TableCell>
                    <Index.TableCell align="center">Action</Index.TableCell>
                  </Index.TableRow>
                </Index.TableHead>
                <Index.TableBody className="table-body">
                  {!loading ? (
                    pageData.length ? (
                      pageData.map((row) => {
                        return (
                          <Index.TableRow key={row?.sNo}>
                            <Index.TableCell align="left">
                              {row?.sNo}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.networkName}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {row?.platformFee}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              <Index.Box className="wallet-address">
                                <Index.Tooltip title={`${row?.networkAddress}`}>
                                  {row?.networkAddress
                                    ? `${row?.networkAddress?.substring(
                                        0,
                                        4
                                      )}.....${row?.networkAddress?.substring(
                                        row?.networkAddress?.length - 4
                                      )}`
                                    : "-"}
                                </Index.Tooltip>
                                {row?.networkAddress && (
                                  <Index.Box style={{ cursor: "pointer" }}>
                                    <ContentCopyIcon
                                      fontSize="small"
                                      onClick={() =>
                                        copyToClipboard(row?.networkAddress)
                                      }
                                    />
                                  </Index.Box>
                                )}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              <Index.Box className="wallet-address">
                                <Index.Tooltip
                                  title={`${row?.receiverAddress}`}
                                >
                                  {row?.receiverAddress
                                    ? `${row?.receiverAddress?.substring(
                                        0,
                                        4
                                      )}.....${row?.receiverAddress?.substring(
                                        row?.receiverAddress?.length - 4
                                      )}`
                                    : "-"}
                                </Index.Tooltip>
                                {row?.receiverAddress && (
                                  <Index.Box style={{ cursor: "pointer" }}>
                                    <ContentCopyIcon
                                      fontSize="small"
                                      onClick={() =>
                                        copyToClipboard(row?.receiverAddress)
                                      }
                                    />
                                  </Index.Box>
                                )}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {moment(row?.createdAt).format(
                                "DD/MM/YYYY hh:mm A"
                              )}
                            </Index.TableCell>
                            <Index.TableCell align="left">
                              {moment(row?.updatedAt).format(
                                "DD/MM/YYYY hh:mm A"
                              ) || "-"}
                            </Index.TableCell>
                            <Index.TableCell className="action-btn-icon">
                              <Index.Box sx={{ display: "flex" }}>
                                <Index.Tooltip
                                  title={`${
                                    row?.isActive ? "Deactive" : "Active"
                                  }`}
                                >
                                  <Index.Switch
                                    className="toggel-switch"
                                    size="small"
                                    {...PagesIndex.label}
                                    checked={row?.isActive ? true : false}
                                    onChange={(event) => {
                                      handleSwitchChange(event, row?._id);
                                    }}
                                  />
                                </Index.Tooltip>
                                <Index.Tooltip title="Edit">
                                  <Index.Button
                                    className="icon-btns"
                                    onClick={() => {
                                      setUpdateCrypto(row);
                                      handleAddMasterWarden();
                                    }}
                                  >
                                    <Index.EditIcon />
                                  </Index.Button>
                                </Index.Tooltip>

                                <Index.Tooltip title="Activity Log">
                                  <Index.Button
                                    className="icon-btns"
                                    onClick={() => handelCrpytoOpen(row?._id)}
                                  >
                                    <Index.WorkHistoryIcon />
                                  </Index.Button>
                                </Index.Tooltip>
                              </Index.Box>
                            </Index.TableCell>
                          </Index.TableRow>
                        );
                      })
                    ) : (
                      <PagesIndex.NoRecordFound colSpan={12} />
                    )
                  ) : (
                    <PagesIndex.PageLoading colSpan={12} />
                  )}
                </Index.TableBody>
              </Index.Table>
            </Index.TableContainer>
          </Index.Box>
          <Index.Box className="pagination-design flex-end">
            <Index.Stack spacing={2}>
              <PagesIndex.Pagination
                fetchData={filterData}
                setPageData={setPageData}
                pageData={pageData}
              />
            </Index.Stack>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      {/* Add Edit Master Warden Popup */}
      <Index.Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="auth-modal login-with-modal"
      >
        <Index.Box
          sx={style}
          className="auth-modal-inner-main login-with-modal-inner-main cypto-list-data"
        >
          <AddCrypto
            handelClose={handelClose}
            getCryptoList={getCryptoList}
            updateCrypto={updateCrypto}
          />
        </Index.Box>
      </Index.Modal>

      <Index.Modal
        open={openActivity}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="auth-modal login-with-modal"
      >
        <Index.Box
          sx={style2}
          className="auth-modal-inner-main login-with-modal-inner-main"
        >
          <ActivityCrypto
            handelClose={handelCrpytoClose}
            updateCrypto={dataCryptoActivity}
            loading={loadingActivity}
            setLoading={setLoadingActivity}
          />
        </Index.Box>
      </Index.Modal>
    </>
  );
};

export default CryptoList;
